import { ChatTurn } from "./chatBotTypes";
import { GroundingSource } from "./ChatSourcesList";

export const CHAT_HISTORY_PAGE_SIZE = 40;

export type RawHistoryItem = {
  role?: string;
  parts?: Array<{ text?: string }>;
  content?: string;
  id?: string;
  is_instruction?: boolean;
  cache_name?: string;
  timestamp?: string;
  grounding_sources?: GroundingSource[];
};

export type PaginatedChatHistoryResponse = {
  history: RawHistoryItem[];
  hasMore?: boolean;
  oldestId?: string;
};

/** Resolve text from Roto↔POC wire parts or legacy Luna content. */
export function historyItemText(item: RawHistoryItem | undefined): string {
  if (!item) {
    return "";
  }
  const fromParts = item.parts?.[0]?.text;
  if (typeof fromParts === "string" && fromParts.length > 0) {
    return fromParts;
  }
  if (typeof item.content === "string") {
    return item.content;
  }
  return typeof fromParts === "string" ? fromParts : "";
}

export function mapRawHistoryToTurns(history: RawHistoryItem[]): ChatTurn[] {
  const turns: ChatTurn[] = [];

  for (let i = 0; i < history.length; i++) {
    const current = history[i];

    if (current.role === "user") {
      const userText = historyItemText(current);
      if (current.is_instruction || userText.includes("<chatbot_instructions>")) {
        continue;
      }

      const next = history[i + 1];
      const isAssistant = next?.role === "model" || next?.role === "assistant";
      const assistantText = isAssistant ? historyItemText(next) : "";
      const historySources: GroundingSource[] =
        isAssistant && Array.isArray(next.grounding_sources) ? next.grounding_sources : [];

      turns.push({
        userTranscript: userText,
        assistantTranscript: assistantText,
        messageId: isAssistant ? next.id : current.id,
        cacheName: isAssistant ? next.cache_name : current.cache_name,
        groundingSources: historySources.length > 0 ? historySources : undefined,
        timestamp: (isAssistant ? next.timestamp : current.timestamp) || undefined,
      });

      if (isAssistant) {
        i++;
      }
    } else if (current.role === "model" || current.role === "assistant") {
      turns.push({
        userTranscript: "",
        assistantTranscript: historyItemText(current),
        messageId: current.id,
        cacheName: current.cache_name,
        timestamp: current.timestamp || undefined,
      });
    }
  }

  return turns;
}
